import { useRouter } from 'next/compat/router'

import { useQueryState } from 'nuqs'

import { INCIDENTS } from '@/utils/routes'

/**
 * The `?displayId` query param names an incident only on the incidents page
 * deep link (`/incidents/?displayId=INC-...`, ENG-30283). Other routes reuse
 * the same param for their own entities (`/case-management?displayId=CAS-...`
 * is the case's displayId), so gating the drawer on it there left the loading
 * skeleton up forever (ENG-33742). Returns the param only on the incidents
 * route; null everywhere else.
 */
export const useIncidentDeepLinkDisplayId = (): string | null => {
  const router = useRouter()
  const [urlDisplayId] = useQueryState('displayId')

  return router?.pathname === INCIDENTS ? urlDisplayId : null
}
